/* eslint-disable */
import React, { Component, createContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import is from 'is_js'
import { em } from 'polished'
import { connect } from 'react-redux'
import { Toast, createToast } from '@binance-chain/honeycomb'
import delayP from 'delay'


import { setWalletConnectURI, setIsconnectedWithWallet } from '../../redux/walletConnect/action'
import WalletConnectClient from '../../utils/integrations/walletConnectClient'
import { Consumer as BNCClientConsumer } from './BNCClientProvider'
import Modal from '../../components/common/Modal'
import Notifycation from '../../components/common/Notifycation'
import { isUnlockWithWalletConnect } from '../../utils/account'
import httpRequest from '../../utils/httpRequest'
import { saveAddress } from '../../utils/storage'
import { setFingerPrint } from '../../utils/fingerPrint'
import { getTokenType } from '../../utils/tokenTypes'
import { getAccount, setAccount } from '../../redux/account/action'
import { getOpenOrdersQS, getOrderHistoryQS } from '../../redux/order/action'
import { getTradeHistoryByAddressQS } from '../../redux/trade/action'

import { withI18n } from '../../i18n/util'

const BRIDGE_URI = null // use default

const ModalBody = styled.div`
  color: inherit;
  text-align: center;
  background: ${({ theme }) => theme.popupBg};
  box-shadow: ${({ theme }) => theme.boxShadow};
`

const ToastContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const ToastTitle = styled.h3`
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.increased)};
  font-weight: bold;
  margin-bottom: ${({ theme }) => em(theme.honeycomb.size.normal)};
`

const ToastDescription = styled.p`
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.normal)};
`

/* **** */

const WalletConnectDelegateConfigurator = ({
  bncClient,
  walletConnectClient,
  preSignCb,
  postSignCb,
  errCb,
  isClientInitailized,
}) => {
  // similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    if (!bncClient || !walletConnectClient) return
    if (!isUnlockWithWalletConnect()) return
    if (!isClientInitailized) return
    const delegate = walletConnectClient.getSigningDelegate(preSignCb, postSignCb, errCb)
    console.log('Setting WalletConnect signing delegate on BncClient.')
    bncClient.setSigningDelegate(delegate)
  })
  return null
}

WalletConnectDelegateConfigurator.propTypes = {
  bncClient: PropTypes.object.isRequired,
  walletConnectClient: PropTypes.object.isRequired,
  isClientInitailized: PropTypes.bool.isRequired,
  preSignCb: PropTypes.func,
  postSignCb: PropTypes.func,
}

WalletConnectDelegateConfigurator.defaultProps = {
  preSignCb: () => {},
  postSignCb: () => {},
}

/* **** */

const Context = createContext({})

class WalletConnectProvider extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    dispatch: PropTypes.func.isRequired,
    triggerElement: PropTypes.element,
    formatI18nText: PropTypes.func,
    address: PropTypes.string,
    isWalletConnect: PropTypes.bool,
    isConnectedWithWallet: PropTypes.bool,
    deviceInfo: PropTypes.object,
  }

  static defaultProps = {
    triggerElement: null,
    address: '',
    formatI18nText: () => {},
    isWalletConnect: false,
    isConnectedWithWallet: false,
    deviceInfo: {},
  }

  constructor(props) {
    super(props)
    this._client = new WalletConnectClient(BRIDGE_URI)
    this._client.on('connect', this._onConnect)
    this._client.on('restore', this._onRestore)
    this._client.on('disconnect', this._onDisconnect)
    this._client.on('session_update', this._onSessionUpdate)
    this.state = {
      showModal: false,
    }
  }

  componentDidMount() {
    window.addEventListener('load', this._pageLoad)
    window.addEventListener('unload', this._pageUnLoad)
  }

  componentWillUnmount() {
    window.removeEventListener('load', this._pageLoad)
    // window.removeEventListener('onbeforeunload', this._pageUnLoad)
  }

  componentDidUpdate(prevProps) {
    const { isConnectedWithWallet } = this.props
    if (isConnectedWithWallet !== prevProps.isConnectedWithWallet) {
      this._notify()
    }
  }

  _pageUnLoad = e => {
    this._client.disconnect()
  }

  _pageLoad = async () => {
    const { isConnectedWithWallet } = this.props
    if (!isConnectedWithWallet) return;

    let walletConnect = localStorage.getItem('walletconnect')
    walletConnect = walletConnect && JSON.parse(walletConnect)
    try {
      if (walletConnect && walletConnect.handshakeTopic) {
        const checkResult = await httpRequest.checkTopic(walletConnect.handshakeTopic)

        if (checkResult && checkResult.isAlive) {
          this._client.restoreSession()
        } else {
          this._reconnect()
        }
      } else {
        this._reconnect()
      }
    } catch (err) {
      this._reconnect()
      console.log(err)
    }
  }

  _onRestore = () => {
    const { dispatch } = this.props
    dispatch(setIsconnectedWithWallet(true))
  }

  _onConnect = ({ accounts }) => {
    const { dispatch, triggerElement, deviceInfo } = this.props
    const flags = {
      isWalletConnect: true,
      isHardWare: true,
    }
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    setFingerPrint(deviceInfo, 'unlock_walletconnect', accounts[0], '')
    dispatch(
      setAccount({
        address: accounts[0],
        flags,
        privateKey: 'HARDWARE',
      })
    )
    dispatch(setWalletConnectURI(''))
    dispatch(setIsconnectedWithWallet(true))
    console.log('testt')

    if (accounts[0] !== user.address) {
      dispatch(getAccount(accounts[0]))
      saveAddress(accounts[0], {
        keystore: 'HARDWARE',
        flags,
      })
      const tokenType = getTokenType()
      const params = {
        address: accounts[0],
        offset: 0,
        total: 1,
        limit: 30,
      }
      dispatch(getOpenOrdersQS({ params, tokenType }))
      dispatch(getOrderHistoryQS({ params, withLoading: true, tokenType }))
      dispatch(getTradeHistoryByAddressQS({ params, withLoading: true, tokenType }))
    } else {
      if (triggerElement && is.function(triggerElement.click)) {
        triggerElement.click()
      }
    }
  }

  _reconnect = async () => {
    const { dispatch } = this.props
    window.localStorage.removeItem('walletconnect')

    if (this._client.connected()) {
      this._client.disconnect()
      await delayP(1000) // to be safe because we cannot await on disconnect
    }

    const uri = await this._client.startSession(false)

    if (window.__DEV__) {
      console.log('WalletConnect URI', uri)
    }

    dispatch(setWalletConnectURI(uri))
  }

  _onDisconnect = async () => {
    const { dispatch } = this.props
    dispatch(setWalletConnectURI(''))
    dispatch(setIsconnectedWithWallet(false))
    await delayP(1000)
    console.log('WalletConnect session disconnected')
    sessionStorage.removeItem('user')
    window.localStorage.removeItem('walletconnect')
    window.location.reload()
  }

  _onSessionUpdate = params => {
    console.log('updated params...')
    console.log(params)
    const { dispatch, triggerElement } = this.props
    dispatch(setWalletConnectURI(''))
    if (triggerElement && is.function(triggerElement.click)) {
      triggerElement.click()
    }
  }

  _showSignModal = () => {
    this.setState({ showModal: true })
  }

  _hideSignModal = () => {
    this.setState({ showModal: false })
  }

  _notify = () => {
    const { isWalletConnect, isConnectedWithWallet } = this.props;
    const notifyMsg = isConnectedWithWallet
      ? 'Mobile Wallet connected'
      : 'Mobile Wallet disconnected'
    if (!isWalletConnect) return;

    createToast(
      <Toast
        icon={isConnectedWithWallet ? <Toast.Icon.Success /> : <Toast.Icon.Danger />}
        data-testid="success-toast"
      >
        <ToastContainer>
          <ToastTitle>Status</ToastTitle>
          <ToastDescription>{notifyMsg}</ToastDescription>
        </ToastContainer>
      </Toast>
    )
  }

  render() {
    const { showModal } = this.state
    const { children, formatI18nText, isConnectedWithWallet } = this.props

    return (
      <Context.Provider value={this._client}>
        <BNCClientConsumer>
          {bncClient => (
            <>
              <WalletConnectDelegateConfigurator
                bncClient={bncClient}
                walletConnectClient={this._client}
                isClientInitailized={this._client.initialized()}
                preSignCb={this._showSignModal}
                postSignCb={this._hideSignModal}
                errCb={this._hideSignModal}
              />
              {children}
            </>
          )}
        </BNCClientConsumer>
        {showModal ? (
          <Modal title={formatI18nText('walletConnect.readyToConfirm')} close={this._hideSignModal}>
            <ModalBody>{formatI18nText('walletConnect.readyToConfirmBody')}</ModalBody>
          </Modal>
        ) : null}
      </Context.Provider>
    )
  }
}

const mapStateToProps = ({
  globalData: { triggerElement, deviceInfo },
  account: {
    address,
    flags: { isWalletConnect },
  },
  walletConnect: { isConnectedWithWallet },
}) => ({
  triggerElement,
  address,
  isWalletConnect,
  isConnectedWithWallet,
  deviceInfo,
})

export const { Provider, Consumer } = Context

export default withI18n(connect(mapStateToProps)(WalletConnectProvider))
